/**
* @file 开发设置
*/
<template>
  <plv-form
    ref="form"
    :model="form"
    :rules="rules"
    form-width="500px"
    label-width="180px"
  >
    <plv-form-item label="分账号用量预警回调" prop="alarmCallbackUrl" tips-inline>
      <plv-input-url
        v-model="form.alarmCallbackUrl"
        placeholder="请输入分账号用量预警回调"
      />
      <template #tips>
        <a href="//help.polyv.net/index.html#/live/api/v4/group/user/callback" target="_blank">查看帮助</a>
      </template>
    </plv-form-item>
    <!-- 提交 -->
    <plv-form-item>
      <plv-button :disabled="loading" @click="onSaveInfo">提交</plv-button>
    </plv-form-item>
  </plv-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        alarmCallbackUrl: ''
      },
      loading: false,
      rules: {
        alarmCallbackUrl: [
          { type: 'url', message: '请输入地址' },
          {
            type: 'string',
            validator: (rule, value, callback) => {
              if (value.length >= 100) {
                callback(new Error('地址长度不得超过120'));
              } else {
                callback();
              }
            }
          },
        ]
      }
    };
  },

  created() {
    this.getDevelopInfo();
  },
  methods: {
    async getDevelopInfo() {
      try {
        this.loading = true;
        this.form = await this.$store.dispatch('account/getDevelopInfo');
      } finally {
        this.loading = false;
      }
    },
    async onSaveInfo() {
      try {
        this.loading = true;
        await this.$refs.form.validate();
        await this.$store.dispatch('account/setDevelopInfo', this.form);
        this.$toast.success('保存成功');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
